import { RemainingTrailerSpace } from './ProgressBarBoxes';

export const getTrailerCapacity = (space?: RemainingTrailerSpace) => {
    const filledTrailerCapacity = Math.ceil(space?.currentlyFilledECEquivalentSpace || 0);
    const maxTrailerCapacity = Math.ceil(
        (space?.currentlyFilledECEquivalentSpace || 0) +
            (space?.remainingSpaceByCarrierTypes?.find((type) => type?.isDefault)
                ?.remainingECEquivalentSpace || 0)
    );

    return {
        filledTrailerCapacity,
        maxTrailerCapacity,
    };
};
